export function requireArenaClock(value:number,label:string):number {
  if(!Number.isFinite(value)||value<0) throw new RangeError(`${label} must be finite and non-negative`)
  return value
}

export function decayImpactEnergy(energy:number,dt:number):number {
  const safeEnergy=requireArenaClock(energy,'impact energy')
  const safeDt=requireArenaClock(dt,'frame delta')
  return Math.max(0,safeEnergy-safeDt*3.8)
}

export function resonanceRotation(elapsedTime:number,special:boolean,impactEnergy:number,impactSpin:number):number {
  const time=requireArenaClock(elapsedTime,'elapsed time')
  const energy=requireArenaClock(impactEnergy,'impact energy')
  if(!Number.isFinite(impactSpin)) throw new RangeError('impact spin must be finite')
  return time*(special?.38:.12)+energy*impactSpin
}
